// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

(function ($) {

  $(".navbar-toggler").click(function(){
    $(".page nav").toggleClass("navbar-closed");
  });

  $(window).scroll(function () {
    var newsrc;

    if ($(this).scrollTop() < 100) {
      $('nav.navbar').addClass('mask-triangle-inverse-bottom');
      $('nav.navbar').addClass('bg-stripes');
      $('nav.navbar').addClass('nav-animate');
      $('nav.navbar').addClass('navbar-light');
      $('nav.navbar').removeClass('bg-small');
      $('nav.navbar').removeClass('navbar-dark');

      newsrc="/themes/custom/bhr/logo.red.svg";
      $('div.navbar-brand__logo img').attr("src", newsrc);
      $('div.navbar-brand__logo img').addClass('logo-large');
      $('div.navbar-brand__logo img').removeClass('logo-small');

      $('body').removeClass('nav-bottom');
      $('body').addClass('nav-top');
    }
    else {
      $('nav.navbar').removeClass('mask-triangle-inverse-bottom');
      $('nav.navbar').addClass('bg-small');
      $('nav.navbar').addClass('navbar-dark');

      $('nav.navbar').removeClass('bg-stripes');
      $('nav.navbar').removeClass('nav-animate');
      $('nav.navbar').removeClass('navbar-light');

      newsrc="/themes/custom/bhr/logo.bridge.svg";
      $('div.navbar-brand__logo img').attr("src", newsrc);
      $('div.navbar-brand__logo img').addClass('logo-small');
      $('div.navbar-brand__logo img').removeClass('logo-large');

      $('body').removeClass('nav-top');
      $('body').addClass('nav-bottom');
    }
  });

})(jQuery);
